import React, { Component } from 'react';
import { string, bool, oneOf } from 'prop-types';
import './progressIndicator.css';

export default class ProgressIndicatorComponent extends Component {
  render() {
    const { indicatorType, indicatorPosition, message, appendEllipses, colorType } = this.props || {};
    const className = `ant-ajax-load ${
      indicatorType === 'Overlay' ? 'progressIndicator-overlay' : ''
    } progressIndicatorPosition-${indicatorPosition.toLowerCase()}`;

    return (
      <div className={className} data-test="progress-loader">
        <div className="sk-spinner sk-spinner-wave ant-ajax-spin">
          <div className={`sk-rect1 ${colorType}`} />
          <div className={`sk-rect2 ${colorType}`} />
          <div className={`sk-rect3 ${colorType}`} />
          <div className={`sk-rect4 ${colorType}`} />
          <div className={`sk-rect5 ${colorType}`} />
        </div>
        {message && (
          <div className={`ant-ajax-text progressMessage ${colorType}`} data-ng-transclude>
            {message + (appendEllipses && '...')}
          </div>
        )}
      </div>
    );
  }
}

ProgressIndicatorComponent.propTypes = {
  message: string,
  appendEllipses: bool,
  colorType: oneOf(['gray', 'blue', 'white']),
  indicatorType: oneOf(['Inline', 'Overlay']),
  indicatorPosition: oneOf(['Left', 'Center', 'Right']),
};

ProgressIndicatorComponent.defaultProps = {
  indicatorType: 'Inline',
  indicatorPosition: 'Center',
  appendEllipses: true,
  colorType: 'gray',
};
